import dayjs from 'dayjs';
import 'dayjs/locale/nl';

dayjs.locale('nl');

export default dayjs;
